import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { EcosystemListingCard } from 'trellis-ecosystem';
import { Slider } from './Slider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SuggestionSection({
  sectionType,
  cards
}) {
  const sectionTitle = sectionType === 'MOST_INSTALLED' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplaceStorefront.suggestionSection.mostInstalled"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplaceStorefront.suggestionSection.newest"
  });
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "1000",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      marginBlockEnd: "600",
      children: sectionTitle
    }), /*#__PURE__*/_jsx(Slider, {
      children: cards.map((item, index) => /*#__PURE__*/_jsx(EcosystemListingCard, Object.assign({
        imageSrcSmall: item.iconUrl
      }, item), index))
    })]
  });
}